<template>
  <div class="step-order-complete">
    <div v-if="order.complete" class="order-success">
      <div class="order-success__body" v-html="orderCompleteHTML" />
      <ReferralCandy />
    </div>
    <div v-else-if="order.loading">
      <p>Loading...</p>
    </div>
    <div v-else-if="order.errorList">
      <h2>An error occured</h2>
      <ul>
        <li v-for="error in order.errorList" :key="error">
          {{error}}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import ReferralCandy from '../components/ReferralCandy.vue';

export default {
  components: { ReferralCandy },
  computed: {
    order() {
      return this.$store.state.order;
    },
    passTypeId() {
      return this.$store.state.order.request.subscriptionTypeId;
    },
    passType() {
      return this.$store.state.passTypes.find(type => type.id === this.passTypeId);
    },
    orderCompleteHTML() {
      let html = this.$store.state.orderCompleteHTML.replace(/{userId}/g, this.order.userId);
      html = html.replace(/{passName}/g, this.passType.name);
      html = html.replace(/{firstName}/g, this.order.request.user.firstName);
      html = html.replace(/{lastName}/g, this.order.request.user.lastName);
      return html;
    },
  },
};
</script>
